// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"5be24aac","453":"c70883a4","498":"734f7821","677":"c29be895","764":"2f7e9a4e","795":"361c1bcc","846":"3f92f0ee","910":"0efe00be"}[chunkId] + ".chunk.js";
};